import { Form, FormProps, Input, Select } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomForm from "../../../components/common/CustomForm";
import {
  ArrayOption,
  pathLink,
  selectSearchOption,
} from "../../../helpers/siteConfig";
import AdminLayout from "../../../layouts/AdminLayout";
import {
  createAreaAsync,
  getAllRegionAsync,
  getSingleAreaAsync,
  updateAreaAsync,
} from "../../../store/features/NP/geoInfo/geoAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { AreaData } from "../../../types/redux";

export default function ManageArea() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [selectRegion, setSelectRegion] = useState("");
  const { postLoading, regions, loading, singleArea, updateLoading } =
    useAppSelector((state) => state.npGeo);
  const location = useLocation();
  const path = pathLink(location.pathname, 1);
  const navLink = `/${path}/geo-info/area`;

  const onFinish: FormProps<AreaData>["onFinish"] = (values) => {
    if (id) {
      dispatch(
        updateAreaAsync({
          data: values,
          others: {
            reRender,
            id,
          },
        })
      );
    } else {
      dispatch(
        createAreaAsync({
          data: values,
          others: {
            reRender,
          },
        })
      );
    }
  };

  // redirect and re-render function
  const reRender = (val: boolean) => {
    if (val) navigate(navLink);
  };

  useEffect(() => {
    dispatch(getAllRegionAsync({}));
  }, [dispatch]);

  useEffect(() => {
    if (id && singleArea && updateLoading === false) {
      setSelectRegion(singleArea?.region?._id);
      form.setFieldsValue({
        region: singleArea?.region?._id,
        areaName: singleArea?.areaName,
      });
    }
  }, [form, id, singleArea, updateLoading]);

  useEffect(() => {
    if (id) {
      dispatch(getSingleAreaAsync({ params: { id } }));
    }
  }, [dispatch, id]);

  return (
    <AdminLayout
      title={id ? "Update zonal" : "Add new zonal"}
      headerTitle="Geo Informations"
    >
      <CustomForm<AreaData>
        onFinish={onFinish}
        title={id ? "Update zonal" : "Add new zonal"}
        formTitle={id ? "Update zonal" : "Add zonal"}
        backLink={navLink}
        disabled={postLoading || updateLoading}
        isUpdate={id ? true : false}
        formProps={{
          form,
        }}
      >
        <Form.Item
          name="region"
          label="Select Cluster"
          rules={[
            {
              required: true,
              message: "Please select cluster",
            },
          ]}
        >
          <Select
            placeholder="Select cluster"
            size="large"
            allowClear
            showSearch
            loading={loading}
            filterOption={selectSearchOption}
            options={ArrayOption(
              [...regions].sort((a, b) =>
                a.regionName.localeCompare(b.regionName)
              ),
              "regionName",
              "_id",
              true
            )}
            onChange={(val) => {
              setSelectRegion(val);
              form.setFieldValue("areaName", undefined);
            }}
            disabled={id ? true : false}
          />
        </Form.Item>
        <Form.Item
          name="areaName"
          label="Zonal Name"
          rules={[
            {
              required: true,
              message: "Please enter zonal name",
            },
          ]}
        >
          <Input
            size="large"
            disabled={!selectRegion}
            placeholder="Enter zonal name"
          />
        </Form.Item>
      </CustomForm>
    </AdminLayout>
  );
}
